const astonVilla = [
  {
    id: 0,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 26/27 - Uniforme 1",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2026",
      "2026 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/26-27-01/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-01/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-01/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-01/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-01/uni4.jpg",
    ],
  },
  {
    id: 1,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 26/27 - Uniforme Edição Especial",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2026",
      "2026 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/26-27-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-00-es/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-00-es/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 26/27 - Uniforme de Pré Jogo",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2026",
      "2026 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/26-27-05-pj/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-05-pj/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-05-pj/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-05-pj/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/26-27-05-pj/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 25/26 - Uniforme 1",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2025",
      "2025 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/25-26-01/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-01/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-01/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-01/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 25/26 - Uniforme 2",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2025",
      "2025 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/25-26-02/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-02/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-02/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-02/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 25/26 - Uniforme 3",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2025",
      "2025 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/25-26-03/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-03/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-03/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-03/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 24/25 - Uniforme 1",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2024",
      "2024 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/24-25-01/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 24/25 - Uniforme 2",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2024",
      "2024 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/24-25-02/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-02/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-02/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-02/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 24/25 - Uniforme 3",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2024",
      "2024 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/24-25-03/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-03/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-03/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-03/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-03/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 24/25 - Uniforme Edição Especial",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2024",
      "2024 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/24-25-00-es/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-00-es/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-00-es/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-00-es/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-00-es/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 24/25 - Uniforme Edição Especial",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2024",
      "2024 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/24-25-01-es1/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01-es1/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01-es1/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01-es1/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/24-25-01-es1/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 21/22 - Uniforme 1",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2021",
      "2021 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/21-22-01/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-01/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-01/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-01/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 21/22 - Uniforme 2",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2021",
      "2021 aston villa",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/21-22-02/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-02/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-02/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-02/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 11/12 - Uniforme 1 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2021",
      "2021 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/11-12-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/11-12-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/11-12-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/11-12-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/11-12-01-rt/uni4.jpg",
    ],
  },
  {
    id: 14,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 09/10 - Uniforme 1 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 2009",
      "2009 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/09-10-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/09-10-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/09-10-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/09-10-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/09-10-01-rt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 99/00 - Uniforme 1 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1999",
      "1999 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/99-00-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/99-00-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/99-00-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/99-00-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/99-00-01-rt/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 98/99 - Uniforme 1 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1998",
      "1998 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/98-99-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/98-99-01-rt/uni1.jpg",
    ],
  },
  {
    id: 17,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 97/98 - Uniforme 2 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1997",
      "1997 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/97-98-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/97-98-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/97-98-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/97-98-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/97-98-02-rt/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 95/96 - Uniforme 2 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1995",
      "1995 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/95-96-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/95-96-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/95-96-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/95-96-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/95-96-02-rt/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 94/95 - Uniforme 3 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1994",
      "1994 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/94-95-03-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/94-95-03-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/94-95-03-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/94-95-03-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/94-95-03-rt/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 93/94 - Uniforme 1 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1993",
      "1993 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/93-94-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-01-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 93/94 - Uniforme 2 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1993",
      "1993 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/93-94-02-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-02-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-02-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-02-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/93-94-02-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "inglaterra",
    liga: "premier-league",
    time: "aston-villa",
    nome: "Aston Villa 90/91 - Uniforme 1 Retrô",
    aliases: [
      "aston villa",
      "aston",
      "villa",
      "the villans",
      "aston villa 1990",
      "1990 aston villa",
      "aston villa retrô",
      "retrô aston villa",
      "retrô",
      "retro",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/inglaterra/premier-league/aston-villa/90-91-01-rt/uni0.jpg",
      "/images/inglaterra/premier-league/aston-villa/90-91-01-rt/uni1.jpg",
      "/images/inglaterra/premier-league/aston-villa/90-91-01-rt/uni2.jpg",
      "/images/inglaterra/premier-league/aston-villa/90-91-01-rt/uni3.jpg",
      "/images/inglaterra/premier-league/aston-villa/90-91-01-rt/uni4.jpg",
    ],
  },
];

export default astonVilla;
